function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Nav, NavItem, NavLink, Progress, TabContent, TabPane, ListGroup, ListGroupItem } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AppSwitch } from '@coreui/react';

var propTypes = {
    children: PropTypes.node
};

var defaultProps = {};

var DefaultAside = function (_Component) {
    _inherits(DefaultAside, _Component);

    function DefaultAside(props) {
        _classCallCheck(this, DefaultAside);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidMount = function () {

            console.log('in component didMount with ' + _this.props.component);
        };

        _this.toggle = _this.toggle.bind(_this);
        _this.state = {
            activeTab: '4'
        };
        return _this;
    }

    DefaultAside.prototype.toggle = function toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    };

    DefaultAside.prototype.render = function render() {
        var _this2 = this;

        // eslint-disable-next-line
        var _props = this.props,
            children = _props.children,
            attributes = _objectWithoutProperties(_props, ['children']);

        return React.createElement(
            React.Fragment,
            null,
            React.createElement(
                Nav,
                { tabs: true },
                React.createElement(
                    NavItem,
                    null,
                    React.createElement(
                        NavLink,
                        { className: classNames({ active: this.state.activeTab === '4' }),
                            onClick: function onClick() {
                                _this2.toggle('4');
                            } },
                        React.createElement('i', { className: 'icon-speech' })
                    )
                ),
                React.createElement(
                    NavItem,
                    null,
                    React.createElement(
                        NavLink,
                        { className: classNames({ active: this.state.activeTab === '1' }),
                            onClick: function onClick() {
                                _this2.toggle('1');
                            } },
                        React.createElement('i', { className: 'icon-list' })
                    )
                ),
                React.createElement(
                    NavItem,
                    null,
                    React.createElement(
                        NavLink,
                        { className: classNames({ active: this.state.activeTab === '2' }),
                            onClick: function onClick() {
                                _this2.toggle('2');
                            } },
                        React.createElement('i', { className: 'icon-speech' })
                    )
                ),
                React.createElement(
                    NavItem,
                    null,
                    React.createElement(
                        NavLink,
                        { className: classNames({ active: this.state.activeTab === '3' }),
                            onClick: function onClick() {
                                _this2.toggle('3');
                            } },
                        React.createElement('i', { className: 'icon-settings' })
                    )
                )
            ),
            React.createElement(
                TabContent,
                { activeTab: this.state.activeTab },
                React.createElement(
                    TabPane,
                    { tabId: '1' },
                    React.createElement(
                        ListGroup,
                        { className: 'list-group-accent' },
                        React.createElement(
                            ListGroupItem,
                            { className: 'list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small' },
                            'Today'
                        ),
                        React.createElement(
                            ListGroupItem,
                            { action: true, tag: 'a', href: '#', className: 'list-group-item-accent-warning list-group-item-divider' },
                            React.createElement(
                                'div',
                                { className: 'avatar float-right' },
                                React.createElement('img', { className: 'img-avatar', src: 'assets/img/avatars/7.jpg', alt: 'admin@bootstrapmaster.com' })
                            ),
                            React.createElement(
                                'div',
                                null,
                                'Meeting with ',
                                React.createElement(
                                    'strong',
                                    null,
                                    'Lucas'
                                ),
                                ' '
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted mr-3' },
                                React.createElement('i', { className: 'icon-calendar' }),
                                '\xA0 1 - 3pm'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                React.createElement('i', { className: 'icon-location-pin' }),
                                ' Palo Alto, CA'
                            )
                        ),
                        React.createElement(
                            ListGroupItem,
                            { action: true, tag: 'a', href: '#', className: 'list-group-item-accent-info list-group-item-divider' },
                            React.createElement(
                                'div',
                                { className: 'avatar float-right' },
                                React.createElement('img', { className: 'img-avatar', src: 'assets/img/avatars/4.jpg', alt: 'admin@bootstrapmaster.com' })
                            ),
                            React.createElement(
                                'div',
                                null,
                                'Skype with ',
                                React.createElement(
                                    'strong',
                                    null,
                                    'Megan'
                                )
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted mr-3' },
                                React.createElement('i', { className: 'icon-calendar' }),
                                '\xA0 4 - 5pm'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                React.createElement('i', { className: 'icon-social-skype' }),
                                ' On-line'
                            )
                        ),
                        React.createElement(
                            ListGroupItem,
                            { className: 'list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small' },
                            'Tomorrow'
                        ),
                        React.createElement(
                            ListGroupItem,
                            { action: true, tag: 'a', href: '#', className: 'list-group-item-accent-danger list-group-item-divider' },
                            React.createElement(
                                'div',
                                null,
                                'New UI Project - ',
                                React.createElement(
                                    'strong',
                                    null,
                                    'deadline'
                                )
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted mr-3' },
                                React.createElement('i', { className: 'icon-calendar' }),
                                '\xA0 10 - 11pm'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                React.createElement('i', { className: 'icon-home' }),
                                '\xA0 creativeLabs HQ'
                            ),
                            React.createElement(
                                'div',
                                { className: 'avatars-stack mt-2' },
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/2.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/3.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/4.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/5.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/6.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                )
                            )
                        ),
                        React.createElement(
                            ListGroupItem,
                            { action: true, tag: 'a', href: '#', className: 'list-group-item-accent-success list-group-item-divider' },
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'strong',
                                    null,
                                    '#10 Startups.Garden'
                                ),
                                ' Meetup'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted mr-3' },
                                React.createElement('i', { className: 'icon-calendar' }),
                                '\xA0 1 - 3pm'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                React.createElement('i', { className: 'icon-location-pin' }),
                                '\xA0 Palo Alto, CA'
                            )
                        ),
                        React.createElement(
                            ListGroupItem,
                            { action: true, tag: 'a', href: '#', className: 'list-group-item-accent-primary list-group-item-divider' },
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'strong',
                                    null,
                                    'Team meeting'
                                )
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted mr-3' },
                                React.createElement('i', { className: 'icon-calendar' }),
                                '\xA0 4 - 6pm'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                React.createElement('i', { className: 'icon-home' }),
                                '\xA0 creativeLabs HQ'
                            ),
                            React.createElement(
                                'div',
                                { className: 'avatars-stack mt-2' },
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/2.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/3.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/4.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/5.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/6.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/7.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'avatar avatar-xs' },
                                    React.createElement('img', { src: 'assets/img/avatars/8.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' })
                                )
                            )
                        )
                    )
                ),
                React.createElement(
                    TabPane,
                    { tabId: '2', className: 'p-3' },
                    React.createElement(
                        'div',
                        { className: 'message' },
                        React.createElement(
                            'div',
                            { className: 'py-3 pb-5 mr-3 float-left' },
                            React.createElement(
                                'div',
                                { className: 'avatar' },
                                React.createElement('img', { src: 'assets/img/avatars/7.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' }),
                                React.createElement('span', { className: 'avatar-status badge-success' })
                            )
                        ),
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                'Lukasz Holeczek'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted float-right mt-1' },
                                '1:52 PM'
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'text-truncate font-weight-bold' },
                            'Lorem ipsum dolor sit amet'
                        ),
                        React.createElement(
                            'small',
                            { className: 'text-muted' },
                            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...'
                        )
                    ),
                    React.createElement('hr', null),
                    React.createElement(
                        'div',
                        { className: 'message' },
                        React.createElement(
                            'div',
                            { className: 'py-3 pb-5 mr-3 float-left' },
                            React.createElement(
                                'div',
                                { className: 'avatar' },
                                React.createElement('img', { src: 'assets/img/avatars/7.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' }),
                                React.createElement('span', { className: 'avatar-status badge-success' })
                            )
                        ),
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                'Lukasz Holeczek'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted float-right mt-1' },
                                '1:52 PM'
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'text-truncate font-weight-bold' },
                            'Lorem ipsum dolor sit amet'
                        ),
                        React.createElement(
                            'small',
                            { className: 'text-muted' },
                            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...'
                        )
                    ),
                    React.createElement('hr', null),
                    React.createElement(
                        'div',
                        { className: 'message' },
                        React.createElement(
                            'div',
                            { className: 'py-3 pb-5 mr-3 float-left' },
                            React.createElement(
                                'div',
                                { className: 'avatar' },
                                React.createElement('img', { src: 'assets/img/avatars/7.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' }),
                                React.createElement('span', { className: 'avatar-status badge-success' })
                            )
                        ),
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                'Lukasz Holeczek'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted float-right mt-1' },
                                '1:52 PM'
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'text-truncate font-weight-bold' },
                            'Lorem ipsum dolor sit amet'
                        ),
                        React.createElement(
                            'small',
                            { className: 'text-muted' },
                            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...'
                        )
                    ),
                    React.createElement('hr', null),
                    React.createElement(
                        'div',
                        { className: 'message' },
                        React.createElement(
                            'div',
                            { className: 'py-3 pb-5 mr-3 float-left' },
                            React.createElement(
                                'div',
                                { className: 'avatar' },
                                React.createElement('img', { src: 'assets/img/avatars/7.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' }),
                                React.createElement('span', { className: 'avatar-status badge-success' })
                            )
                        ),
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                'Lukasz Holeczek'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted float-right mt-1' },
                                '1:52 PM'
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'text-truncate font-weight-bold' },
                            'Lorem ipsum dolor sit amet'
                        ),
                        React.createElement(
                            'small',
                            { className: 'text-muted' },
                            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...'
                        )
                    ),
                    React.createElement('hr', null),
                    React.createElement(
                        'div',
                        { className: 'message' },
                        React.createElement(
                            'div',
                            { className: 'py-3 pb-5 mr-3 float-left' },
                            React.createElement(
                                'div',
                                { className: 'avatar' },
                                React.createElement('img', { src: 'assets/img/avatars/7.jpg', className: 'img-avatar', alt: 'admin@bootstrapmaster.com' }),
                                React.createElement('span', { className: 'avatar-status badge-success' })
                            )
                        ),
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                'Lukasz Holeczek'
                            ),
                            React.createElement(
                                'small',
                                { className: 'text-muted float-right mt-1' },
                                '1:52 PM'
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'text-truncate font-weight-bold' },
                            'Lorem ipsum dolor sit amet'
                        ),
                        React.createElement(
                            'small',
                            { className: 'text-muted' },
                            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...'
                        )
                    )
                ),
                React.createElement(
                    TabPane,
                    { tabId: '3', className: 'p-3' },
                    React.createElement(
                        'h6',
                        null,
                        'Settings'
                    ),
                    React.createElement(
                        'div',
                        { className: 'aside-options' },
                        React.createElement(
                            'div',
                            { className: 'clearfix mt-4' },
                            React.createElement(
                                'small',
                                null,
                                React.createElement(
                                    'b',
                                    null,
                                    'Option 1'
                                )
                            ),
                            React.createElement(AppSwitch, { className: 'float-right', variant: 'pill', label: true, color: 'success', defaultChecked: true, size: 'sm' })
                        ),
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                            )
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'aside-options' },
                        React.createElement(
                            'div',
                            { className: 'clearfix mt-3' },
                            React.createElement(
                                'small',
                                null,
                                React.createElement(
                                    'b',
                                    null,
                                    'Option 2'
                                )
                            ),
                            React.createElement(AppSwitch, { className: 'float-right', variant: 'pill', label: true, color: 'success', size: 'sm' })
                        ),
                        React.createElement(
                            'div',
                            null,
                            React.createElement(
                                'small',
                                { className: 'text-muted' },
                                'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                            )
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'aside-options' },
                        React.createElement(
                            'div',
                            { className: 'clearfix mt-3' },
                            React.createElement(
                                'small',
                                null,
                                React.createElement(
                                    'b',
                                    null,
                                    'Option 3'
                                )
                            ),
                            React.createElement(AppSwitch, { className: 'float-right', variant: 'pill', label: true, color: 'success', defaultChecked: true, size: 'sm', disabled: true }),
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'small',
                                    { className: 'text-muted' },
                                    'Option disabled.'
                                )
                            )
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'aside-options' },
                        React.createElement(
                            'div',
                            { className: 'clearfix mt-3' },
                            React.createElement(
                                'small',
                                null,
                                React.createElement(
                                    'b',
                                    null,
                                    'Option 4'
                                )
                            ),
                            React.createElement(AppSwitch, { className: 'float-right', variant: 'pill', label: true, color: 'success', defaultChecked: true, size: 'sm' })
                        )
                    ),
                    React.createElement('hr', null),
                    React.createElement(
                        'h6',
                        null,
                        'System Utilization'
                    ),
                    React.createElement(
                        'div',
                        { className: 'text-uppercase mb-1 mt-4' },
                        React.createElement(
                            'small',
                            null,
                            React.createElement(
                                'b',
                                null,
                                'CPU Usage'
                            )
                        )
                    ),
                    React.createElement(Progress, { className: 'progress-xs', color: 'info', value: '25' }),
                    React.createElement(
                        'small',
                        { className: 'text-muted' },
                        '348 Processes. 1/4 Cores.'
                    ),
                    React.createElement(
                        'div',
                        { className: 'text-uppercase mb-1 mt-2' },
                        React.createElement(
                            'small',
                            null,
                            React.createElement(
                                'b',
                                null,
                                'Memory Usage'
                            )
                        )
                    ),
                    React.createElement(Progress, { className: 'progress-xs', color: 'warning', value: '70' }),
                    React.createElement(
                        'small',
                        { className: 'text-muted' },
                        '11444GB/16384MB'
                    ),
                    React.createElement(
                        'div',
                        { className: 'text-uppercase mb-1 mt-2' },
                        React.createElement(
                            'small',
                            null,
                            React.createElement(
                                'b',
                                null,
                                'SSD 1 Usage'
                            )
                        )
                    ),
                    React.createElement(Progress, { className: 'progress-xs', color: 'danger', value: '95' }),
                    React.createElement(
                        'small',
                        { className: 'text-muted' },
                        '243GB/256GB'
                    ),
                    React.createElement(
                        'div',
                        { className: 'text-uppercase mb-1 mt-2' },
                        React.createElement(
                            'small',
                            null,
                            React.createElement(
                                'b',
                                null,
                                'SSD 2 Usage'
                            )
                        )
                    ),
                    React.createElement(Progress, { className: 'progress-xs', color: 'success', value: '10' }),
                    React.createElement(
                        'small',
                        { className: 'text-muted' },
                        '25GB/256GB'
                    )
                ),
                React.createElement(
                    TabPane,
                    { tabId: '4' },
                    React.createElement(
                        ListGroup,
                        { className: 'list-group-accent' },
                        React.createElement(
                            ListGroupItem,
                            { className: 'list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small' },
                            'BASIC MODULE'
                        ),
                        React.createElement(
                            ListGroupItem,
                            {
                                draggable: true,
                                onDragStart: function onDragStart(event) {
                                    event.dataTransfer.setData("storm-diagram-node", JSON.stringify({ "text": "ciao" }));
                                },
                                action: true, tag: 'a', href: '#', className: 'list-group-item-accent-warning list-group-item-divider' },
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'strong',
                                    null,
                                    'Text'
                                ),
                                ' module'
                            ),
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'small',
                                    null,
                                    'Simple Text Module'
                                )
                            )
                        ),
                        React.createElement(
                            ListGroupItem,
                            {
                                draggable: true,
                                onDragStart: function onDragStart(event) {
                                    event.dataTransfer.setData("storm-diagram-node", JSON.stringify({ "text": "ciao" }));
                                },
                                action: true, tag: 'a', href: '#', className: 'list-group-item-accent-primary list-group-item-divider' },
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'strong',
                                    null,
                                    'Button'
                                ),
                                ' module'
                            )
                        )
                    )
                )
            )
        );
    };

    return DefaultAside;
}(Component);

DefaultAside.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DefaultAside.defaultProps = defaultProps;

export default DefaultAside;